<!-- src/app/components/revoke-token-modal/revoke-token-modal.component.html -->
<div class="modal-header">
  <h4 class="modal-title">Revoke Token</h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>Are you sure you want to revoke this token?</p>
</div>

<div class="content">
  <button type="button" class="iso-round-button iso-secondary mr-2" (click)="revoke()">Revoke</button>
  <button type="button" class="iso-round-button mr-2" (click)="cancel()">Cancel</button>

</div>
